// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-index-productDay-bikih{width:100%}.pages-index-productDayWrapper-ryfqa.pages-index-mobile-vkixz{margin-left:-16px;margin-right:-16px}.pages-index-productsBlock3-nsyqr{margin-bottom:24px}.pages-index-productsBlock3-nsyqr:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productDay": "pages-index-productDay-bikih",
	"productDayWrapper": "pages-index-productDayWrapper-ryfqa",
	"mobile": "pages-index-mobile-vkixz",
	"productsBlock3": "pages-index-productsBlock3-nsyqr"
};
module.exports = ___CSS_LOADER_EXPORT___;
